const space = {
  "4.5": "1.125rem"
};

export { space as default };
